
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/rokt",
      function () {
        return require("private-next-pages/destinations/rokt.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/rokt"])
      });
    }
  